export enum Status {
    InActive = 0,
    Active = 1
}
